export const passwordRules = [
  {
    title: '8 Character Minimum',
    required: true,
    validFunc: (pass: string) => pass.length > 7
  },
  {
    title: 'Uppercase Character',
    required: true,
    validFunc: (pass: string) => Number(pass.search(/[A-Z]/)) !== -1
  },
  {
    title: 'Lowercase Character',
    required: true,
    validFunc: (pass: string) => Number(pass.search(/[a-z]/)) !== -1
  },
  {
    title: 'Number',
    required: true,
    validFunc: (pass: string) => Number(pass.search(/\d/)) !== -1
  },
  // {
  //   title: 'Special Character',
  //   required: false,
  //   validFunc: (pass: string) => Number(pass.search(/[^a-z\d\s]/gi)) !== -1
  // },
  {
    title: 'Confirm Password',
    required: true,
    validFunc: (pass: string, confirmPass: string) =>
      Boolean(pass) && pass === confirmPass
  }
];

export const MULTIPLE_CLIENT_RECORDS_ERROR = 'Multiple Client Records';
